<style scoped lang="scss" src="./Modal.scss"></style>
<template>
  <main class="modal-root__container__main">
    <slot/>
  </main>
</template>
<script>
export default {
  name: "ModalMain"
}
</script>
